import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { useAuth } from "./useAuth";

const ANONYMOUS_QUERY_CACHE_IDENTITY = "anonymous";

export function AuthQueryCacheBoundary() {
  const { user, loading } = useAuth();
  const queryClient = useQueryClient();
  const previousIdentityRef = useRef<string | null>(null);
  const identity = loading
    ? null
    : user
      ? `${user.role}:${user.id}`
      : ANONYMOUS_QUERY_CACHE_IDENTITY;

  useEffect(() => {
    if (identity === null) return;

    const previousIdentity = previousIdentityRef.current;
    if (previousIdentity === null) {
      previousIdentityRef.current = identity;
      return;
    }

    if (previousIdentity !== identity) {
      queryClient.clear();
      previousIdentityRef.current = identity;
    }
  }, [identity, queryClient]);

  return null;
}
